import { FeatureFlag } from '../FeatureFlag';

export const showRecentlyUsedIdeaIndicators = new FeatureFlag({
    key: 'show-recently-used-idea-indicators',
    createdOn: '2025-11-25',
    defaultValue: false,
});
